import { yccApi } from "@/service/api";
import { getRpc } from "ycc-api/src/service/Rpc";

const Rpc = getRpc(yccApi);

export default Rpc;
